import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, error => {

  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurred.");
  }

  return Promise.reject(error);
});

axios.defaults.headers.common['Accept'] = "application/json";
axios.defaults.headers.common['Content-Type'] = "application/json";

function setRequestHeaderAuth(jwt) {
  axios.defaults.headers.common['Authorization'] = jwt;
}

export default {
  setRequestHeaderAuth,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete
};
